import { CAPS_LOCK_WARNING } from "constants/settings";

export const profileRequestStatusSchema = {
  title: "Profile Request Details",
  logicalname: "ProfileRequestStatus",
  type: "object",
  description: "",
  additionalDescription: CAPS_LOCK_WARNING,
  properties: {
    ctpt_employer: {
      title: "Employer Name",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
    ctpt_name: {
      title: "Requested By",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
    ctpt_reasonforcontacting: {
      title: "Reason for Contacting",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
    ctpt_daterequested: {
      title: "Request Date",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
    ctpt_approved: {
      title: "Approved",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
    ctpt_rejected: {
      title: "Rejected",
      type: "string",
      datatype: "string",
      requiredCheck: false,
      pattern: "",
      message: "",
      disabled: true,
    },
  },
};

